import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/bookmarkActionFilled.svg';

export const IconBookmarkActionFilled = createIconComponent(Icon);
